import { Card, CardBody, CardTitle, Progress, Row, Col } from "reactstrap";

const donutTrackColor = "#E4E5E7";
const donutFillColor = "#F6BC63";

const ComplianceReadinessChart = ({
  t,
  readinessScore,
  applicabilityScore,
  maturityScore,
  taskHealthScore,
  showMaturity = false,
}) => {
  const safeReadiness = Math.max(0, Math.min(100, Number(readinessScore || 0)));
  const safeApplicability = Math.max(0, Math.min(100, Number(applicabilityScore || 0)));
  const safeMaturity = Math.max(0, Math.min(100, Number(maturityScore || 0)));
  const safeTaskHealth = Math.max(0, Math.min(100, Number(taskHealthScore || 0)));

  return (
    <Card className="card_box_Shadow h-100">
      <CardBody>
        <CardTitle>{t("Compliance Readiness")}</CardTitle>

        <Row className="mt-4 align-items-center g-3">
          <Col lg="5" md="5" sm="12" className="d-flex justify-content-center">
            <div
              className="compliance-readiness-donut"
              style={{
                background: `conic-gradient(${donutFillColor} ${safeReadiness}%, ${donutTrackColor} 0%)`,
              }}
            >
              <div className="compliance-readiness-donut__inner">
                <div className="compliance-readiness-donut__value">{safeReadiness}%</div>
                <div className="compliance-readiness-donut__label">{t("Overall Score")}</div>
              </div>
            </div>
          </Col>

          <Col lg="7" md="7" sm="12">
            <div className="compliance-readiness-metric mb-3">
              <p className="compliance-readiness-metric__label mb-0">
                {t("Applicability score")}
              </p>
              <div className="compliance-readiness-metric__bar-row">
                <Progress value={safeApplicability} color="primary" style={{ height: 10 }} />
                <span>{safeApplicability}%</span>
              </div>
            </div>

            {showMaturity ? (
              <div className="compliance-readiness-metric mb-3">
                <p className="compliance-readiness-metric__label mb-0">{t("Maturity score")}</p>
                <div className="compliance-readiness-metric__bar-row">
                  <Progress value={safeMaturity} color="info" style={{ height: 10 }} />
                  <span>{safeMaturity}%</span>
                </div>
              </div>
            ) : null}

            <div className="compliance-readiness-metric">
              <p className="compliance-readiness-metric__label mb-0">{t("Task Health score")}</p>
              <div className="compliance-readiness-metric__bar-row">
                <Progress value={safeTaskHealth} color="success" style={{ height: 10 }} />
                <span>{safeTaskHealth}%</span>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ComplianceReadinessChart;
